import { AccessibilityType } from "@/common/models/model";
import { IContextPropsModel, IFormPropsModel } from "@/common/utils/withContext";
import { IUserProfileModel } from "@/store/auth/types";

export class ChargingStationFormModel {
  siteArea: string = "";
  siteAreaID: string = "";
  siteName: string = "";
  powerLimitUnit: string[] = [];
  siteAddress: string = "";
  tariffID?: any = null;
  accessibility: AccessibilityType = AccessibilityType.PUBLIC;
  public?: boolean = false;
  maximumAmps: number = 0;
  maximumPower: number = 0;
  masterSlave: boolean = false;
  manualConfiguration: boolean = false;
  issuer: boolean = false;
  id: string = "";
  excludeFromSmartCharging: boolean = false;
  forceInactive: boolean = false;
  coordinates?: CoordinatesModel;
  chargingStationURL?: any = null;
  chargePoints: any[] = [];
  canGetConnectorQrCode?: boolean = false;
  connectors?: ConnectorsModel[] = [];
  capabilities?: any = null;
  site?: string = "";
  url?: any = null;
  canUpdateFirmware?: boolean = false;
  ocppProtocol?: any = "";
  ocppVersion?: string = "";
  chargePointVendor?: string = "";
  chargePointModel?: string = "";
  chargePointSerialNumber?: string = "";
  chargeBoxSerialNumber?: string = "";
  iccid?: any = null;
  imsi?: any = null;
  meterSerialNumber?: any = null;
  meterType?: any = null;
  endpoint?: string = "";
  currentIPAddress?: string = "";
  lastReboot?: string = "";
  lastSeen?: string = "";
  firmwareVersion?: string = "";
  createdOn?: string = "";
  chargerStatus?: any = "";
  checkStatus?: any = "";
  tracking?: any;
  notes?: any;
  chargerType?: "AC" | "DC";
  ratedAmp: string = "";
  ratedPower: string = "";
  versionFlag?: boolean = false;
  phaseAssignment?: any;
  /** Selected template in UI before/during apply; optional when an applied template exists on `auditLogs`. */
  templateId: string | null = null;
  auditLogs?: {
    templateId?: string;
    templateName?: string;
    createdOn?: string;
    createdBy?: string;
    status?: string;
    templateDescription?: string;
  } = {};
  constructor() {
    this.coordinates = { ...new CoordinatesModel() };
  }
}

export class CoordinatesModel {
  longitude?: any = "";
  latitude?: any = "";
}
export class ConnectorsModel {
  connectorId?: number = 0;
  amperagePerPhase?: number = 0;
  amperage?: number = 0;
  currentType?: string = "";
  numberOfConnectedPhase?: number = 1;
  voltage?: number = 230;
  type?: string = "";
  tariffID?: string = "";
  power?: number = 0;
  phaseAssignmentToGrid?: any;
  phaseAssignment?: any;
  shrink?: boolean = false;
  ratedAmp?: number = 0;
  ratedPower?: number = 0;
}

export interface IEditChargingStationFormPropsModel
  extends IContextPropsModel,
    IFormPropsModel<ChargingStationFormModel> {
  onFormClose: () => void;
  chargingStationId: string;
  userInfo: IUserProfileModel;
  editChargingStationForm?: boolean;
  canUpdateChargingStation?: boolean;
  siteAreaName?: string;
  siteName?: string;
  siteId?: string;
  limit?: number;
  fetchAllChargingStations: () => void;
  onStatusSelect?: any;
  checkState?: any;
  notesTab?: boolean;
  setParentStateData?: any;
  commStatus?: string;
  chargeBoxId?: string;
}
